import { $contacts } from "../services/Index";
/* eslint-disable */
export const contactMixin = {
  data() {
    return {
      companyList: [],
      searchCompanyKeyword: null,
    };
  },
  computed: {
    associatedField() {
      return this.$store.getters["contacts/associatedField"];
    },
  },
  watch: {
    searchAgentKeyword(val) {
      this.pageNo = 1;
      this.getCompanyList(val);
    },
  },
  mounted() {
    this.companyList = this.associatedField.companyList;
    this.getCompanyList()
  },
  methods: {
    async getCompanyList() {
      try {
        const response = await $contacts.fetchCompanyList({}, {});
        if (response.data) {
          let dummyElement = "--"
          response.data.unshift(dummyElement)
          this.$store.dispatch("contacts/companyList", [response.data]);
        }
      } catch (error) {}
    },
  }
};
